import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import { Badge } from 'antd'
import { getRoleAccessKeySelector } from '../../store/selectors/app.selector'
import { useSelector } from 'react-redux'
import './approval.css'
import DashboardService from '../../services/dashboard.service'
import { APPROVAL_SUB_MENUS } from '../../api/menu-details'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import { useTranslation } from 'react-i18next';

export default function Approvals() {
  const history = useHistory()
  const [subMenuList, setSubMenuList] = useState([])
  const [approvalCount, setApprovalCount] = useState([])
  const roleAccessKey = useSelector(getRoleAccessKeySelector)
  const {t}=useTranslation()

  useEffect(() => {
    getSubMenus()
    getApprovalNotification()
    return () => {}
  }, [])

  const getSubMenus = useCallback(async () => {
    try {
      const response = await DashboardService.getSubMenus('PENDING')
      if (response.status === 200) {
        console.log(response.data)
        setSubMenuList(response.data)
      }
    } catch (err) {}
  }, [])

  const getApprovalNotification = useCallback(async () => {
    try {
      const response = await DashboardService.getApprovalNotification()
      if (response.status === 200) {
        console.log(response.data)
        setApprovalCount(response.data)
      }
    } catch (err) {}
  }, [])

  return (
    <LayoutWithOutAccountCard
      keyPath={'APPROVAL'}
      showEmptySpace={true}
      breadCumKey='APPROVALS'>
      <Row>
        {subMenuList.map((option, index) => (
          <div>
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              className='account-menu-card'
              onClick={() => history.push(APPROVAL_SUB_MENUS.LINKS[option?.screenCode])}>
              <img width={46} height={40} src={APPROVAL_SUB_MENUS.ICONS[option?.screenCode]} />
              <h2>{t(APPROVAL_SUB_MENUS.TITLE[option?.screenCode])}</h2>
            </Col>

            {roleAccessKey !== 'I' &&
              approvalCount[
                APPROVAL_SUB_MENUS.NOTIFICATION_POINT[t(APPROVAL_SUB_MENUS.TITLE[option?.screenCode])]
              ] !== 0 && (
                <Badge
                  count={
                    approvalCount[
                      APPROVAL_SUB_MENUS.NOTIFICATION_POINT[
                        t(APPROVAL_SUB_MENUS.TITLE[option?.screenCode])
                      ]
                    ]
                  }
                  offset={[176, -212]}
                  className="approval-badge-color"
                  style={{
                    // backgroundColor: '#b23437',
                    fontSize: '12px',
                    height: '25px',
                    width: '25px',
                    borderRadius: '50px',
                  }}></Badge>
              )}
          </div>
        ))}
      </Row>
    </LayoutWithOutAccountCard>
  )
}
